import { useParams } from 'react-router-dom';
import { extractMerchantSlugFromUrl } from 'utils/url';

function useMerchantIdOrSlug() {
  const { merchantId } = useParams();

  return merchantId || process.env.REACT_APP_MERCHANT_SLUG || extractMerchantSlugFromUrl();
}

export default useMerchantIdOrSlug;
